package org.braunequip.web.components.forms.Maintenance

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import kotlinx.datetime.LocalDate
import org.braunequip.web.components.models.CompleteMaintItemRequest
import org.braunequip.web.components.models.MaintItemsDTO
import org.braunequip.web.util.*
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement

@Composable
fun MaintItemDetails(
    item: MaintItemsDTO,
    onConfirm: (CompleteMaintItemRequest) -> Unit,
    onDismiss: () -> Unit
) {
    Box(
        modifier = Modifier
            .width(100.vw)
            .height(100.vh)
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .zIndex(19),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(20.px)
                .margin(top = 4.cssRem)
                .padding(1.cssRem)
                .zIndex(20)
                .width(min(350.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically
            ) {
                H2(
                    attrs = Modifier
                        .fontFamily(FONT_FAMILY2)
                        .fontSize(1.cssRem)
                        .margin(topBottom = 8.px)
                        .fontWeight(FontWeight.Bold)
                        .toAttrs()
                ) {
                    Text("Maintenance Item Details")
                }
                Spacer()
                FaX(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onDismiss()
                        }
                        .color(Colors.Grey)
                )
            }
            HorizontalDivider(Modifier.margin(topBottom = 4.px))

            H2(
                attrs = Modifier
                    .fontFamily(FONT_FAMILY2)
                    .margin(bottom = 6.px)
                    .fontSize(1.2.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text("${item.scheduleId} - ${item.scheduleName}")
            }

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .fontSize(1.cssRem),
                horizontalAlignment = Alignment.Start,
            ) {
                SpanText(
                    text = "Due Miles: ${item.dueMiles?.pretty() ?: "-"}",
                    Modifier
                        .margin(bottom = 6.px)
                )

                SpanText(
                    text = "Due Date: ${item.dueDate ?: "-"}",
                    Modifier
                        .margin(bottom = 6.px)
                )

                SpanText(
                    text = "Status: ${MaintItemStatus.fromId(item.status!!)?.label ?: "-"}",
                    Modifier
                        .margin(bottom = 6.px)
                )

                SpanText(
                    text = "Created: ${ item.createdAt?.let { formatDate(it) } ?: "-"}",
                    Modifier
                        .margin(bottom = 6.px)
                )

                SpanText(
                    text = "Completed: ${ item.completedDate?.let { formatDateTime(it) } ?: "-" }",
                    Modifier
                        .margin(bottom = 6.px)
                )

                SpanText(
                    text = "Completed: ${ item.completedBy ?: "-" }",
                    Modifier
                        .margin(bottom = 6.px)
                )
            }



            Button(
                attrs = Modifier
                    .classNames("button")
                    .backgroundColor(Theme.Primary.rgb)
                    .color(Colors.White)
                    .onClick {
                        onDismiss()
                    }
                    .toAttrs()
            ) {
                Text("Close")
            }
        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.DarkerGray.rgb)
                .position(Position.Fixed)
                .padding(top = 5.cssRem)
                .onClick {
                    onDismiss()
                }
                .zIndex(19),
            contentAlignment = Alignment.TopCenter
        )
    }
}